"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactsApi = void 0;
var _authentication = require("../../../authentication");
var _config = require("../../../config");
var _ReleaseStage = require("../Models/ReleaseStage");
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var ArtifactsApi = {
  getArtifacts: function () {
    var _getArtifacts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(productId, artifactType) {
      var useAutoAssignedPipelines,
        includeProperties,
        includeOnlyActiveAssignments,
        adToken,
        apiHost,
        queryParams,
        requestUrl,
        request,
        response,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              useAutoAssignedPipelines = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              includeProperties = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
              includeOnlyActiveAssignments = _args.length > 4 && _args[4] !== undefined ? _args[4] : true;
              _context.next = 5;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 5:
              adToken = _context.sent;
              apiHost = _config.Config.getValue("UI:PRODCAT_API_URL");
              queryParams = "";
              if (artifactType) {
                queryParams += "artifactType=".concat(artifactType);
              }
              queryParams += "&useAutoAssignedPipelines=".concat(useAutoAssignedPipelines, "&includeProperties=").concat(includeProperties, "&includeOnlyActiveAssignments=").concat(includeOnlyActiveAssignments);
              requestUrl = "".concat(apiHost, "/products/").concat(productId, "/artifacts?").concat(queryParams);
              request = new Request(requestUrl, {
                method: "GET",
                headers: {
                  Authorization: "Bearer ".concat(adToken)
                }
              });
              _context.next = 14;
              return fetch(request);
            case 14:
              response = _context.sent;
              if (!(response.status === 200)) {
                _context.next = 21;
                break;
              }
              _context.next = 18;
              return response.json();
            case 18:
              return _context.abrupt("return", _context.sent.value);
            case 21:
              throw Error(response.statusText);
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function getArtifacts(_x, _x2) {
      return _getArtifacts.apply(this, arguments);
    }
    return getArtifacts;
  }(),
  getArtifactsWithPaging: function () {
    var _getArtifactsWithPaging = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(productId, artifactType, pageSize) {
      var continuationToken,
        includeProperties,
        includeOnlyActiveAssignments,
        useAutoAssignedPipelines,
        adToken,
        apiHost,
        requestUrl,
        request,
        response,
        responseJson,
        _responseJson$continu,
        _responseJson$continu2,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              continuationToken = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              includeProperties = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : false;
              includeOnlyActiveAssignments = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : true;
              useAutoAssignedPipelines = _args2.length > 6 && _args2[6] !== undefined ? _args2[6] : false;
              _context2.next = 6;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 6:
              adToken = _context2.sent;
              apiHost = _config.Config.getValue("UI:PRODCAT_API_URL");
              requestUrl = "".concat(apiHost, "/products/").concat(productId, "/artifacts?artifactType=").concat(artifactType, "&pageSize=").concat(pageSize, "&useAutoAssignedPipelines=").concat(useAutoAssignedPipelines, "&includeProperties=").concat(includeProperties, "&includeOnlyActiveAssignments=").concat(includeOnlyActiveAssignments);
              if (continuationToken) {
                requestUrl += "&continuationToken=".concat(encodeURIComponent(continuationToken));
              }
              request = new Request(requestUrl, {
                method: "GET",
                headers: {
                  Authorization: "Bearer ".concat(adToken)
                }
              });
              _context2.next = 13;
              return fetch(request);
            case 13:
              response = _context2.sent;
              _context2.next = 16;
              return response.json();
            case 16:
              responseJson = _context2.sent;
              if (!(response.status === 200)) {
                _context2.next = 21;
                break;
              }
              return _context2.abrupt("return", {
                artifacts: responseJson.value,
                continuationToken: (_responseJson$continu = responseJson === null || responseJson === void 0 ? void 0 : (_responseJson$continu2 = responseJson.continuationToken) === null || _responseJson$continu2 === void 0 ? void 0 : _responseJson$continu2.value) !== null && _responseJson$continu !== void 0 ? _responseJson$continu : null
              });
            case 21:
              throw Error(response.statusText);
            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function getArtifactsWithPaging(_x3, _x4, _x5) {
      return _getArtifactsWithPaging.apply(this, arguments);
    }
    return getArtifactsWithPaging;
  }(),
  updateRepoAutoAssignmentStatus: function () {
    var _updateRepoAutoAssignmentStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(productId, artifactType, artifactId, useAutoAssignment) {
      var adToken, apiHost, request, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 2:
              adToken = _context3.sent;
              apiHost = _config.Config.getValue("UI:PRODCAT_API_URL");
              request = new Request("".concat(apiHost, "/products/").concat(productId, "/repoAutoAssignmentStatus?artifactType=").concat(artifactType, "&artifactId=").concat(artifactId, "&useAutoAssignment=").concat(useAutoAssignment), {
                method: "PUT",
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                }
              });
              _context3.next = 7;
              return fetch(request);
            case 7:
              response = _context3.sent;
              if (response.ok) {
                _context3.next = 10;
                break;
              }
              throw new Error("Update repo artifact use auto assignment failed. Did not get status response ok.");
            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    function updateRepoAutoAssignmentStatus(_x6, _x7, _x8, _x9) {
      return _updateRepoAutoAssignmentStatus.apply(this, arguments);
    }
    return updateRepoAutoAssignmentStatus;
  }(),
  updatePipelineAutoAssignmentStatus: function () {
    var _updatePipelineAutoAssignmentStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(productId, artifactType, artifactId, isManuallyUnassigned) {
      var adToken, apiHost, request, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 2:
              adToken = _context4.sent;
              apiHost = _config.Config.getValue("UI:PRODCAT_API_URL");
              request = new Request("".concat(apiHost, "/products/").concat(productId, "/artifacts/pipelineAutoAssignmentStatus?artifactType=").concat(artifactType, "&artifactId=").concat(artifactId, "&isManuallyUnassigned=").concat(isManuallyUnassigned), {
                method: "PUT",
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                }
              });
              _context4.next = 7;
              return fetch(request);
            case 7:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 10;
                break;
              }
              throw new Error("Update pipeline auto assignment status failed. Did not get status response ok.");
            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    function updatePipelineAutoAssignmentStatus(_x0, _x1, _x10, _x11) {
      return _updatePipelineAutoAssignmentStatus.apply(this, arguments);
    }
    return updatePipelineAutoAssignmentStatus;
  }(),
  getReleaseDefinitionStages: function () {
    var _getReleaseDefinitionStages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(organization, projectId, definitionId, releaseDefinitionArtifactId) {
      var adToken, releaseStages, apiHost, requestUrl, request, response, errorMessage, environments, _iterator, _step, environment, releaseStage;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _authentication.AuthTokenProvider.acquireVstsToken();
            case 2:
              adToken = _context5.sent;
              releaseStages = [];
              apiHost = _config.Config.getValue("UI:VSRM_URL");
              requestUrl = "".concat(apiHost, "/").concat(organization, "/").concat(projectId, "/_apis/release/definitions/").concat(definitionId, "?api-version=6.0");
              request = new Request(requestUrl, {
                method: "GET",
                headers: {
                  Authorization: "Bearer ".concat(adToken)
                }
              });
              _context5.next = 9;
              return fetch(request);
            case 9:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 15;
                break;
              }
              _context5.next = 13;
              return response.json();
            case 13:
              errorMessage = _context5.sent.message;
              throw new Error(errorMessage);
            case 15:
              _context5.next = 17;
              return response.json();
            case 17:
              environments = _context5.sent.environments;
              _iterator = _createForOfIteratorHelper(environments);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  environment = _step.value;
                  releaseStage = new _ReleaseStage.ReleaseStage(environment.id, environment.name, environment.rank, releaseDefinitionArtifactId);
                  releaseStage.organizationName = organization;
                  releaseStages.push(releaseStage);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context5.abrupt("return", releaseStages);
            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    function getReleaseDefinitionStages(_x12, _x13, _x14, _x15) {
      return _getReleaseDefinitionStages.apply(this, arguments);
    }
    return getReleaseDefinitionStages;
  }(),
  //TODO: Why do we pass in an ArtifactIdentifier which contains the artifactType and also pass in artifactType as a separate parameter?
  //TODO: Could we just pass in an Artifact instead of an ArtifactIdentifier?
  writeSingleProductArtifact: function () {
    var _writeSingleProductArtifact = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(productId, artifact, artifactType) {
      var artifactToSave, adToken, apiHost, request, response, errorMessage;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              artifactToSave = {
                artifactId: artifact.artifactId,
                artifactType: artifact.artifactType
              };
              _context6.next = 3;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 3:
              adToken = _context6.sent;
              apiHost = _config.Config.getValue("UI:PRODCAT_API_URL");
              request = new Request("".concat(apiHost, "/products/").concat(productId, "/artifacts?artifactType=").concat(artifactType, "&artifactId=").concat(artifact.artifactId), {
                method: "PUT",
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                },
                body: JSON.stringify(artifactToSave)
              });
              _context6.next = 8;
              return fetch(request);
            case 8:
              response = _context6.sent;
              if (!response.ok) {
                _context6.next = 15;
                break;
              }
              _context6.next = 12;
              return response.json();
            case 12:
              return _context6.abrupt("return", _context6.sent);
            case 15:
              _context6.next = 17;
              return response.json();
            case 17:
              errorMessage = _context6.sent.message;
              throw new Error(errorMessage);
            case 19:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    function writeSingleProductArtifact(_x16, _x17, _x18) {
      return _writeSingleProductArtifact.apply(this, arguments);
    }
    return writeSingleProductArtifact;
  }(),
  deleteSingleProductArtifact: function () {
    var _deleteSingleProductArtifact = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(productId, artifactType, artifactId) {
      var adToken, apiHost, request, response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _authentication.AuthTokenProvider.acquireProdcatToken();
            case 2:
              adToken = _context7.sent;
              apiHost = _config.Config.getValue("UI:PRODCAT_API_URL");
              request = new Request("".concat(apiHost, "/products/").concat(productId, "/artifacts?artifactType=").concat(artifactType, "&artifactId=").concat(artifactId), {
                method: "DELETE",
                headers: {
                  Authorization: "Bearer ".concat(adToken),
                  "content-type": "application/json"
                }
              });
              _context7.next = 7;
              return fetch(request);
            case 7:
              response = _context7.sent;
              if (response.ok) {
                _context7.next = 10;
                break;
              }
              throw new Error("Delete artifact failed");
            case 10:
              return _context7.abrupt("return", Promise.resolve());
            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    function deleteSingleProductArtifact(_x19, _x20, _x21) {
      return _deleteSingleProductArtifact.apply(this, arguments);
    }
    return deleteSingleProductArtifact;
  }()
};
exports.ArtifactsApi = ArtifactsApi;